<table class="mav-table" mat-table [dataSource]="items$">
  <caption></caption>
  <ng-container [matColumnDef]="column" *ngFor="let column of displayedColumns">
    <th scope="col" mat-header-cell *matHeaderCellDef>{{ columns[column].label }}</th>
    <td mat-cell *matCellDef="let element"
      [class.selected]="element.pulse"
      [style.background-color]="element.color || undefined"
      [ngSwitch]="columns[column].type"
      (click)="rowClicked($event, element)">

      <img alt="" class="image-url" *ngSwitchCase="'imageUrl'" [src]="element[column]">
      <ng-template ngSwitchDefault>{{ element[column] }}</ng-template>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
